import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col" }
const _hoisted_2 = { class: "flex flex-col w-full bg-brand-black my-auto h-full" }
const _hoisted_3 = { class: "flex flex-col m-auto items-center w-full px-6 space-y-14 pt-20" }
const _hoisted_4 = { class: "flex flex-col items-center space-y-14" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-2 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex mx-auto text-white text-2xl font-medium" }, "Thank you for telling us about your experience"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-lg" }, "Sharing your experience isn’t always easy, and we appreciate it when you do. Your safety is important to us, each report allows us to maintain a safe space for all Pineapple users.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Done")
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_mark = _resolveComponent("logo-mark")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { class: "flex flex-col h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_logo_mark),
                  _hoisted_5
                ]),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args))),
                  class: "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
                }, _hoisted_7)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}